import { useTranslation } from "hooks/useTranslation";
import Head from "layout/Head";
import React, { Fragment } from "react";
import {
  SIMPLE_DEPLOYMENT_MOBILE_CONFIG,
  SIMPLE_DEPLOYMENT_SWITCHING_TAB,
  DEPLOYMENT_HERO_SECTION,
} from "./GettingStartedWithUniFi.config";
import { ModelCompareTab } from "./GettingStartedWithUniFi.types";
import { SwitchingCompact } from "@ubnt/store.core/lib/constants/modelCompareData/data/SwitchingCompact";
import { PhysicalSecurityOverview } from "@ubnt/store.core/lib/constants/modelCompareData/data/PhysicalSecurityOverview";
import { WifiFlagship } from "@ubnt/store.core/lib/constants/modelCompareData/data/WifiFlagship";
import { ExtendedTabId } from "components/ExtendedTabs/ExtendedTabs.types";
import { HowItWorksPage } from "components/HowItWorksPage";
import { MODEL_COMPARE_TABS } from "./shared.config";
import SimpleDeploymentRiv from "./assets/rive/simple-deployment.riv";
import SimpleDeploymentMobileRiv from "./assets/rive/simple-deployment-mobile.riv";

const MODEL_COMPARE_DATA_BY_ID = {
  [ModelCompareTab.Switching]: SwitchingCompact,
  [ModelCompareTab.AccessPoints]: WifiFlagship,
  [ModelCompareTab.Cameras]: PhysicalSecurityOverview,
  [ModelCompareTab.DoorAccess]: null,
};

export const GettingStartedWithUniFi = () => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <Head
        title={t("gettingStartedWithUniFi.seo.title")}
        description={t("gettingStartedWithUniFi.seo.description")}
        url="https://ui.com/how-it-works"
        image="https://www.ui.com/microsite/og-image.png"
      />

      <HowItWorksPage
        hero={{
          title: "gettingStartedWithUniFi.hero.title",
          config: DEPLOYMENT_HERO_SECTION,
          mobileConfig: SIMPLE_DEPLOYMENT_MOBILE_CONFIG,
        }}
        topology={{
          title: "gettingStartedWithUniFi.topology.intro.title",
          description: "gettingStartedWithUniFi.topology.intro.description",
          config: {
            src: SimpleDeploymentRiv,
          },
          mobileConfig: {
            src: SimpleDeploymentMobileRiv,
          },
        }}
        activePageId={ExtendedTabId.SmallDeployment}
        compareTabs={[SIMPLE_DEPLOYMENT_SWITCHING_TAB, ...MODEL_COMPARE_TABS]}
        compareOptions={MODEL_COMPARE_DATA_BY_ID}
      />
    </Fragment>
  );
};
